function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 75,
  height: 18,
  rx: 4,
  fill: "#E2E2E3"
});
var _ref3 = /*#__PURE__*/React.createElement("text", {
  x: "50%",
  y: "50%",
  dominantBaseline: "middle",
  fontFamily: "Calibri",
  fontSize: 13,
  textAnchor: "middle",
  fontWeight: "bold",
  fill: "Grey"
}, "Non-VMI");
const SvgNonVmiSite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 66,
    height: 18,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgNonVmiSite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/non-vmi-site.2e9ea4e2.svg";
export { ForwardRef as ReactComponent };